import { Component, Input, OnInit } from '@angular/core';
import { ValidatorMessageModel } from './validator-message.model';

@Component({
  selector: 'app-validation',
  templateUrl: './validation.component.html',
  styleUrls: ['./validation.scss'],
})
export class ValidationComponent implements OnInit {
  @Input() validationMessages?: ValidatorMessageModel[];

  constructor() {}

  ngOnInit(): void {}
}
